import React from 'react'
import {useTheme} from '@mui/material'
import {Bar, BarChart, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis} from 'recharts'
import {useTranslation} from 'react-i18next'
import {AllDeviceActivity} from '@containers/device/containers/deviceActivity/types'

export interface IActivityRow {
	value: keyof AllDeviceActivity
	label: string
	color: string
	count: number
}

interface IProps {
	rows: IActivityRow[]
	onSelect: (key: keyof AllDeviceActivity) => void
}

const ActivityBars = ({rows, onSelect}: IProps) => {
	const {t} = useTranslation()
	const theme = useTheme()

	const data = rows.map((item) => ({
		...item,
		name: t(`dashboardPage.short.${item.value}`),
		title: t(item.label),
	}))

	return (
		<ResponsiveContainer width={'100%'} height={230}>
			<BarChart data={data} margin={{top: 24, right: 4, left: 4, bottom: 0}} barCategoryGap={'22%'}>
				<XAxis
					dataKey={'name'}
					tickLine={false}
					axisLine={{stroke: theme.palette.divider}}
					interval={0}
					tick={{fontSize: 11, fill: theme.palette.text.secondary}}
				/>
				<Tooltip
					cursor={{fill: theme.palette.action.hover, radius: 6}}
					formatter={(value: number) => [value.toLocaleString('uk-UA'), '']}
					labelFormatter={(_, payload) => payload?.[0]?.payload?.title ?? ''}
					contentStyle={{
						borderRadius: 8,
						border: `1px solid ${theme.palette.divider}`,
						background: theme.palette.background.paper,
					}}
				/>
				<Bar
					dataKey={'count'}
					radius={[6, 6, 0, 0]}
					minPointSize={3}
					cursor={'pointer'}
					animationDuration={700}
					onClick={(_, index) => onSelect(rows[index].value)}
				>
					{data.map((item) => <Cell key={item.value} fill={item.color}/>)}
					<LabelList
						dataKey={'count'}
						position={'top'}
						formatter={(value: number) => value.toLocaleString('uk-UA')}
						style={{fontSize: 12, fontWeight: 600, fill: theme.palette.text.primary}}
					/>
				</Bar>
			</BarChart>
		</ResponsiveContainer>
	)
}

export default ActivityBars
